export default "__VITE_ASSET__BgBI7h1O__"